import React, { useEffect, useState } from 'react'
import MyListBlock from '../../../../UI/list/MyListBlock'
import { getUserName } from '../../../../../helpers/user/UserHelper'
import { departmentText } from '../../../../../helpers/department/DepartmentHelper'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import SupplierContactsShort from '../../../supplier/view/contacts/short/SupplierContactsShort'

const SupplyBillClient = ({ supplyBillId }) => {

    const supplyBill = useSelector(state => state.supplyBill.supplyBill)

    const [list, setList] = useState([])

    useEffect(() => {
        setListItems()
    }, [supplyBill.user, supplyBill.supplier])

    const setListItems = () => {
        const listTemp = []

        // listTemp.push({
        //     name: 'Замовник',
        //     value: client ? getUserName({ user: client }) : '-'
        // })
        listTemp.push({
            name: 'Підрядник',
            value: 
                supplyBill.supplier ? 
                    <Link to={`/supply/suppliers/${supplyBill.supplier.id}`}>
                        {`${supplyBill.supplier.name} (${supplyBill.supplier.edrpou})`}
                    </Link>
                : '-'
        })
        listTemp.push({
            name: 'Контакти',
            value: 
                supplyBill.supplier ? 
                    <SupplierContactsShort 
                        contacts={supplyBill.supplier.contacts}
                    />
                : '-'
        })
        listTemp.push({
            name: 'Відповідальний',
            value: 
                supplyBill.user ? 
                    <div>
                        {getUserName({ user: supplyBill.user })}
                        {/* <EditUserInSupplyOrderButton 
                            supplyBillId={supplyOrderId} 
                            user={user} 
                        /> */}
                    </div>
                :
                    // <EditUserInSupplyOrderButton 
                    //     supplyOrderId={supplyOrderId} 
                    // />
                    '-'
        })

        setList(listTemp)
    }

  return (
    <MyListBlock
        className={'supplyOrderView__topBlock'}
        text={'Підрядник'}
        list={list}
    />
    // <div className='supplyOrderView__client'>
    //     client
    // </div>
  )
}

export default SupplyBillClient